import Chart from "react-apexcharts";

export default function GraficoPie({ title, labels, values }) {
    const options = {
        chart: {
            type: "donut"
        },
        labels: labels, // categorias
        legend: {
            fontSize: "12px",
            labels: { colors: "#333" },
        },
        tooltip: {
            y: {
                formatter: (value) =>
                    Number(value).toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                    }),
            }
        },
        responsive: [
            {
                breakpoint: 768,
                options: {
                    legend: { position: "bottom" },
                },
            },
        ],
    };

    const series = values;

    return (
        <div className="bg-white p-4 rounded-2xl shadow-md fade-in">
            <h2 className="text-xl font-bold mb-2">{title}</h2>
            {values.length > 0  ?
                <Chart options={options} series={series} type="pie" height={350} />
                :
                "Não existem dados disponíveis para o intervalo selecionado."
            }
        </div>
    );
}
